module.exports = __webpack_public_path__ + "img/weixin.66e5fd83.png";